import { GlobalWorkerOptions, version as pdfJsVersion } from 'pdfjs-dist';

type PromiseWithPolyfills = typeof Promise & {
	try?: <T>(fn: (...args: unknown[]) => T | PromiseLike<T>, ...args: unknown[]) => Promise<T>;
	withResolvers?: <T>() => {
		promise: Promise<T>;
		resolve: (value: T | PromiseLike<T>) => void;
		reject: (reason?: unknown) => void;
	};
};

const promiseCtor = Promise as PromiseWithPolyfills;

const PDF_WORKER_POLYFILLS = `
if(typeof Promise.try!=="function"){Promise.try=function(fn,...args){return new Promise((resolve,reject)=>{try{resolve(fn(...args))}catch(error){reject(error)}})}}
if(typeof Promise.withResolvers==="undefined"){Promise.withResolvers=function(){let resolve,reject;const promise=new Promise((res,rej)=>{resolve=res;reject=rej});return{promise,resolve,reject}}}
`;

const PDF_WORKER_PATH = '/assets/pdfjs/pdf.worker.min.mjs';

export function applyPromisePolyfills(): void {
	if (typeof promiseCtor.try !== 'function') {
		promiseCtor.try = <T>(fn: (...args: unknown[]) => T | PromiseLike<T>, ...args: unknown[]): Promise<T> =>
			new Promise((resolve, reject) => {
				try {
					resolve(fn(...args));
				} catch (error) {
					reject(error);
				}
			});
	}

	if (typeof promiseCtor.withResolvers !== 'function') {
		promiseCtor.withResolvers = <T>() => {
			let resolve!: (value: T | PromiseLike<T>) => void;
			let reject!: (reason?: unknown) => void;
			const promise = new Promise<T>((res, rej) => {
				resolve = res;
				reject = rej;
			});
			return { promise, resolve, reject };
		};
	}
}

function setWorkerSrc(workerSrc: string): void {
	GlobalWorkerOptions.workerSrc = workerSrc;
	(window as any).pdfWorkerSrc = workerSrc;
	(window as any)[`pdfWorkerSrc${pdfJsVersion}`] = workerSrc;
}

export async function configurePdfWorker(): Promise<void> {
	applyPromisePolyfills();

	try {
		const response = await fetch(PDF_WORKER_PATH);
		if (!response.ok) {
			throw new Error(`Failed to load PDF worker: ${response.status}`);
		}

		const workerCode = await response.text();
		const blob = new Blob([PDF_WORKER_POLYFILLS + workerCode], { type: 'text/javascript' });
		setWorkerSrc(URL.createObjectURL(blob));
	} catch {
		setWorkerSrc(PDF_WORKER_PATH);
	}
}
